<div class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th *ngIf="!isCapstone" colspan="2" translate>ID</th>
        <th *ngIf="isCapstone" translate>ID</th>
        <th translate>NAME</th>
        <th *ngIf="isCapstone" translate>AVAILABILITY</th>
        <th *ngIf="!isCapstone" translate>VOLUME</th>
        <th translate>PACKAGE_SIZE</th>
        <th translate>PRICE</th>

        <th style="min-width: 200px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of mappedData">
        <td
          *ngIf="!isCapstone"
          style="border-left: 10px solid"
          [ngStyle]="{ 'border-left-color': item.product.extra.hexBorderColor }"
        ></td>
        <td *ngIf="item.replacementId == null">
          <a routerLink="/product/{{ item.id }}" class="text-dark">
            {{ item.id }}
          </a>
        </td>
        <td *ngIf="item.replacementId != null">
          <span [ngbPopover]="popContent2" triggers="mouseenter" [autoClose]="'outside'">
            <a routerLink="/product/{{ item.id }}" class="text-red">
              {{ item.id }} <i class="fas fa-exclamation-triangle"></i>
            </a>
          </span>
          <ng-template #popContent2>
            <div class="row">
              <div class="col text-center">
                <span translate>PRODUCT_REPLACED_BY</span> <br />
                <a routerLink="/product/{{ item.id }}" class="text-dark">
                  {{ item.replacementId }}
                </a>
              </div>
            </div>
          </ng-template>
        </td>
        <td>
          <a routerLink="/product/{{ item.id }}" class="text-dark">
            {{ item.name }}
          </a>
        </td>
        <td *ngIf="isCapstone">
          <lib-availability [availability]="item.availability"></lib-availability>
        </td>
        <td *ngIf="!isCapstone">
          {{ item.product.extra.ar.artbeskrspec }}
        </td>
        <td>
          {{ item.product.extra.ar.artfsgforp }}
        </td>
        <td>
          <span *ngIf="item.price">
            <span *ngIf="item.price.customerDiscountPercent === 0" class="mr-1" translate>NET_PRICE</span>
            <lib-price
              *ngIf="item.price.customerDiscountPercent === 0; else netPrice"
              [price]="item.price"
              type="NET"
            ></lib-price>
            <ng-template #netPrice>
              <lib-price
                [price]="item.price"
                type="GROSS"
              ></lib-price>
            </ng-template>
            <span *ngIf="item.price.customerDiscountPercent !== 0">(-{{ item.price.customerDiscountPercent }}%)</span>
          </span>
        </td>
        <td style="width: 200px">
          <div *ngIf="isCapstone; else otherProject">
            <lib-buy-btn [id]="item.id"> </lib-buy-btn>
          </div>

          <ng-template #otherProject>
            <lib-buy-btn [id]="item.id" [stepAmount]="item.packageSize"> </lib-buy-btn>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
</div>
